"use client"

/**
 * ListPageTabs — publication-state switcher with inline counts.
 *
 * Replaces the ad-hoc Select/filter-card patterns used before. Follows
 * the Pages list's existing Tabs pattern and generalizes it.
 */

import { Tabs } from "antd"
import type { ReactNode } from "react"

export interface ListPageTabItem {
  key: string
  label: ReactNode
  /** When provided, renders inline next to label as a muted count. */
  count?: number
}

interface ListPageTabsProps {
  items: ListPageTabItem[]
  activeKey: string
  onChange: (key: string) => void
}

export function ListPageTabs({ items, activeKey, onChange }: ListPageTabsProps) {
  return (
    <Tabs
      activeKey={activeKey}
      onChange={onChange}
      type="line"
      size="middle"
      tabBarStyle={{ marginBottom: 12 }}
      items={items.map(item => ({
        key: item.key,
        label: (
          <span className="inline-flex items-center gap-2">
            <span>{item.label}</span>
            {typeof item.count === "number" && (
              <span
                style={{
                  fontSize: 12,
                  color: "var(--admin-muted-fg)",
                  fontWeight: 400,
                  fontVariantNumeric: "tabular-nums",
                }}
              >
                · {item.count}
              </span>
            )}
          </span>
        ),
      }))}
    />
  )
}

export default ListPageTabs
